import PayinFeesService from "@/services/PayinFeesService";

const INITIAL_PAGINATION = {
  pageIndex: 0,
  pageSize: 0,
  totalElements: 0,
  totalPages: 0
};

const state = {
  fees: [],
  pagination: { ...INITIAL_PAGINATION }
};

const mutations = {
  setFees(state, value) {
    state.fees = value;
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

const getters = {
  fees: state => state.fees,
  payinFeesPagination: state => state.pagination
};

const actions = {
  getPrefilledFees (_, payload) {
    return PayinFeesService.getFees(payload);
  },

  createFees (_, payload) {
    return PayinFeesService.createFees(payload);
  },

  deleteFees (_, payload) {
    return PayinFeesService.deleteFees(payload);
  },

  updateFees (_, payload) {
    return PayinFeesService.updateFees(payload);
  },

  exportCsv(_, payload) {
    return PayinFeesService.exportCsv(payload);
  },

  async getFees({ commit }, payload) {
    try {
      const { list, pagination } = await PayinFeesService.getFees(payload);
      commit("setFees", list);
      commit("setPagination", pagination);
    } catch (error) {
      commit("setFees", []);
      commit("setPagination", INITIAL_PAGINATION);
    }
  },

  async uploadFees(_, payload) {
    return await PayinFeesService.uploadFees(payload);
  },
  async previewFees(_, payload) {
    return await PayinFeesService.previewFees(payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
